function get_timezone_abbr(date){
    var result = "unknown";
    try{
        // Chrome, Firefox
        result = /.*\s(.+)/.exec((date).toLocaleDateString(navigator.language, { timeZoneName:'short' }))[1];
    }catch(e){
        // IE, some loss in accuracy due to guessing at the abbreviation
        // Note: This regex adds a grouping around the open paren as a
        //       workaround for an IE regex parser bug
        result = (date).toTimeString().match(new RegExp("[A-Z](?!.*[\(])","g")).join('');
    }
    return result;
}

function get_timezone_name(date) {
    const short = date.toLocaleDateString(undefined);
    const full = date.toLocaleDateString(undefined, { timeZoneName: 'long' });
  
    const shortIndex = full.indexOf(short);
    if (shortIndex >= 0) {
      const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);
      return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, '');
  
    } else {
      return full;
    }
}

function pad(value) {
    return value < 10 ? '0' + value : value;
}

function createOffset(date) {
    var sign = (date.getTimezoneOffset() > 0) ? "-" : "+";
    var offset = Math.abs(date.getTimezoneOffset());
    var hours = pad(Math.floor(offset / 60));
    var minutes = pad(offset % 60);
    return sign + hours + ":" + minutes;
}
  
function get_timezone_obj (){
    const date = new Date();
    const tz = {
        td_db: Intl.DateTimeFormat().resolvedOptions().timeZone,
        offset: createOffset(date),
        name: get_timezone_name(date),
        tz_abbr: get_timezone_abbr(date)
    };
    return tz;
}

function auto_update_tz(id){
    const $select = am.$(document).find('#'+id);
    var tz_obj = get_timezone_obj();
    const opts = $select.children('option');
    opts.each(function(index, el){
        const $this = am.$(el);
        if($this.data('name_value') && $this.data('name_value') == tz_obj.td_db){
            $this.prop('selected', true);
        }
    })
}